import { render, staticRenderFns } from "./modalDokumenPdf.vue?vue&type=template&id=331faa79&"
import script from "./modalDokumenPdf.vue?vue&type=script&lang=js&"
export * from "./modalDokumenPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports